import merge from 'lodash-es/merge';
import useDefaultChartOptions from '@/components/charts/useDefaultChartOptions';
import usePieChartOptions from '@/components/charts/usePieChartOptions';
import { roundIfNecessary } from '@/util/helpers/numbers';
import { CourseStatistics, Gender, genderTranslation } from '@/types';

export const getEndedEventsGendersConfig = (id: string, group: number, endedCourseStatistics: CourseStatistics[]) => {
    return {
        id,
        group,
        printTitle: 'Kønsfordeling (afsluttede forløb)',
        options: merge(useDefaultChartOptions(), usePieChartOptions(), {
            title: { text: 'Kønsfordeling' },
            series: {
                tooltip: {
                    pointFormatter() {
                        return `<span style="color:${(this as any).color}">●</span> Antal: <b>${(this as any).y}</b><br/><span style="color:${(this as any).color}">●</span> Fordeling: <b>${roundIfNecessary(
                            (this as any).percentage,
                            1
                        )}%</b><br/>`;
                    },
                },
                data: [
                    {
                        name: genderTranslation[Gender.Male],
                        y: endedCourseStatistics.filter((currentCourseStatistic) => currentCourseStatistic.gender === Gender.Male).length,
                    },
                    {
                        name: genderTranslation[Gender.Female],
                        y: endedCourseStatistics.filter((currentCourseStatistic) => currentCourseStatistic.gender === Gender.Female).length,
                    },
                    {
                        name: genderTranslation[Gender.Other],
                        y: endedCourseStatistics.filter((currentCourseStatistic) => currentCourseStatistic.gender === Gender.Other).length,
                    },
                    {
                        name: genderTranslation.unknown,
                        y: endedCourseStatistics.filter((currentCourseStatistic) => !currentCourseStatistic.gender).length,
                    },
                ].map((currentDataPoint) => {
                    return {
                        ...currentDataPoint,
                        dataLabels: {
                            distance: currentDataPoint.y > 0 ? '-50%' : '30',
                        },
                    };
                }),
            },
        }),
    };
};
